import { useQuery } from '@tanstack/react-query'
import { getOpeningTimes, getOverallOpeningTimes } from '../../../services/Metrics/Metrics.service'

const useOverallOpeningTimes = ({ from, to, enabled = true }) => {
    return useQuery({
        queryFn: () => getOverallOpeningTimes(from, to),
        queryKey: ['metrics', 'scope-open-metrics', from, to],
        enabled
    })
}

const useOpeningTimes = ({ from, to, page, size, posIds, enabled = true }) => {
    return useQuery({
        queryFn: () => getOpeningTimes(from, to, page, size, posIds),
        queryKey: ['metrics', 'pos-open-metrics', from, to, page, size, posIds],
        enabled
    })
}

export { useOverallOpeningTimes, useOpeningTimes }
